import * as React from 'react';
import Buttons from './components/Buttons';
import ColorPalette from './components/ColorPalette';
import Forms from './components/Forms';
import Iconography from './components/Iconography';
import Typography from './components/Typography';

const Title = ({ text }) => (
  <div className='py-10 px-8 bg-primary text-white mt-24 mb-16'>
    <p className='h2 mb-0'>{text}</p>
  </div>
);

const Home = () => {
  return (
    <div className='container'>
      <Title text='Color Palette' />
      <ColorPalette />
      <Title text='Typography' />
      <Typography />
      <Title text='Buttons' />
      <Buttons />
      <Title text='Iconography' />
      <Iconography />
      <Title text='Forms' />
      <Forms />
    </div>
  );
};

export default Home;
